import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';

/**
 * Frontend-Helper: liest die enabled-Feature-Flags vom Backend (5-Min-Cache).
 * Wird genutzt um UI-Elemente konditional zu zeigen (z.B. Time-Tracking-Tab).
 */

interface FeatureFlagsResponse {
  flags: Record<string, boolean>;
}

export function useFeatureFlags() {
  return useQuery({
    queryKey: ['feature-flags'],
    queryFn: async () => {
      const { data } = await api.get<FeatureFlagsResponse>('/feature-flags');
      return data.flags;
    },
    staleTime: 5 * 60 * 1000,
  });
}

export function useIsFeatureEnabled(key: string): boolean {
  const query = useFeatureFlags();
  return query.data?.[key] === true;
}
